import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import umgLogo from 'assets/svg/umg-logo-colored.svg';

import Img from 'components/Img';

import messages from './messages';

const UMGLogo = ({ logoUrl, imageAlt, ...cssProps }) => {
  const { formatMessage } = useIntl();

  return (
    <Img
      {...cssProps}
      height={50}
      maxHeight={50}
      maxWidth={200}
      src={logoUrl ?? umgLogo}
      alt={imageAlt ?? formatMessage(messages.defaultMSULogoAlt)}
    />
  );
};

UMGLogo.propTypes = {
  logoUrl: PropTypes.string,
  imageAlt: PropTypes.string,
};

export default memo(UMGLogo);
